module.exports = __webpack_public_path__ + "static/media/009-Foto_ID_2.b58153db.mp3";